import { Action } from 'redux';
import { AmplitudeCustomerData, AmplitudeEvent } from '../@types';

export enum AmplitudeActionType {
	RequestInitialize = 'requestAmplitudeInitialize',
	RequestEvent = 'requestAmplitudeEvent'
}

export type AmplitudeInitializeAction = Action<typeof AmplitudeActionType.RequestInitialize> & {
	data: AmplitudeCustomerData;
};

export type AmplitudeEventAction<T extends Record<string, unknown> | undefined = undefined> = Action<
	typeof AmplitudeActionType.RequestEvent
> & {
	event: AmplitudeEvent<T>;
};

export function requestInitializeAmplitude(data: AmplitudeCustomerData): AmplitudeInitializeAction {
	return {
		data,
		type: AmplitudeActionType.RequestInitialize
	};
}

export function requestAmplitudeEvent<T extends Record<string, unknown> | undefined>(
	event: AmplitudeEvent<T>
): AmplitudeEventAction<T> {
	return {
		event,
		type: AmplitudeActionType.RequestEvent
	};
}
